import {TileSize} from 'quickstart/components/tizra/MetaTile'
import {
  ImageCropping,
  ImageFocus,
  SlotConfig,
  SlotName,
} from 'quickstart/components/tizra/MetaTile/common'
import {UseSearchReturn} from 'quickstart/hooks'
import {ReactNode} from 'react'
import {logger, MetaObject} from 'tizra'
import {CardsGallery} from './galleries/cards'
import {DigestsGallery} from './galleries/digests'
import {HeadlineGallery} from './galleries/headline'
import {ListGallery} from './galleries/list'
import {TilesGallery} from './galleries/tiles'
import {TitlesGallery} from './galleries/titles'

const log = logger('BrowseGallery')

type Display = 'cards' | 'digests' | 'list' | 'headline' | 'titles' | 'tiles'

export type BrowseGalleryProps = {
  display: Display
  search: UseSearchReturn<MetaObject>
  maxItems?: number
  size?: TileSize
  slots?: {[k in SlotName]?: SlotConfig}
  background?: string
  foreground?: string
  linkColor?: string
  twoColumnHeadline?: boolean
  imageCropping?: ImageCropping
  imageFocus?: ImageFocus
}

const displayGalleries = {
  cards: CardsGallery,
  digests: DigestsGallery,
  headline: HeadlineGallery,
  list: ListGallery, // TODO: seems disused
  titles: TitlesGallery,
  tiles: TilesGallery,
} as const satisfies {[k in Display]: (props: BrowseGalleryProps) => ReactNode}

export const BrowseGallery = (props: BrowseGalleryProps) => {
  let GalleryComponent = displayGalleries[props.display]

  if (!GalleryComponent) {
    log.error(`unknown display: ${props.display}`)
    GalleryComponent = CardsGallery
  }

  return <GalleryComponent {...props} />
}
